firebird.directive('emailValidator', function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, elm, attrs, ctrl) {
            // Same regex we use to validate email on Node server (helpers\emailValidator.helper.js)
            // Copied from CPS.STS email-validator: https://tfs.intermedia.net/tfs/DefaultCollection/Intermedia/_git/CPS.STS?path=%2FHosting.STS%2FHost.AD%2Fwwwroot%2FShared%2Femail-validator.js&version=GBdevelop&line=5&lineEnd=5&lineStartColumn=9&lineEndColumn=147&lineStyle=plain&_a=contents
            const emailRegex =
                /^[a-z0-9!%&'+_{}\-=]+(\.[a-z0-9!%&'+_{}\-=]+)*@[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*\.[a-z]{2,14}$/i;

            // only apply the validator if ngModel is present and AngularJS has added the email validator
            if (ctrl && ctrl.$validators.email) {
                // this will overwrite the default AngularJS email validator
                ctrl.$validators.email = function (modelValue) {
                    return ctrl.$isEmpty(modelValue) || emailRegex.test(modelValue);
                };
            }
        }
    };
});
